export default function($) {
  const $langBtn = $('[aria-controls="language-switcher-dropdown"]');
  const $langDropdown = $('#language-switcher-dropdown');

  function open() {
    $langBtn.attr('aria-expanded', 'true');
    $langDropdown.removeClass('hidden');
  }

  function close() {
    $langBtn.attr('aria-expanded', 'false');
    $langDropdown.addClass('hidden');
  }

  $langBtn.on('click', function() {
    $(this).attr('aria-expanded') === 'true' ? close() : open();
  });

  $langBtn.closest('.language-switcher-button').on('mouseenter', function() {
    open();
  }).on('mouseleave', function() {
    close();
  });

  $(document).on('click', function(event) {
    if (!$(event.target).closest('[aria-controls="language-switcher-dropdown"], #language-switcher-dropdown').length) {
      close();
    }
  });

  $langBtn.on('keydown', function(event) {
    if (event.key === 'Escape') {
      close();
      $(this).trigger('focus');
    }
  });
}
